import React, { useState, useRef } from 'react'
import Accordion from '../../../components/accordion'

// --------------------------------------------------------------------------------
const initialAccordionsState = {
  availability: {
    name: 'availability',
    open: false,
  },
  paying: {
    name: 'paying',
    open: false,
  },
  afterSold: {
    name: 'afterSold',
    open: false,
  },
  cost: {
    name: 'cost',
    open: false,
  },
}

// ----------------------------------------------------------------------

export default function FAQ() {
  const accordionsRef = useRef({})
  const [accordionsState, setAccordionsState] = useState(initialAccordionsState)

  const handleAccordionToggle = (name) => {
    setAccordionsState((prev) => ({ ...prev, [name]: { ...prev[name], open: !prev[name].open } }))
  }

  return (
    <div className='root'>
      <h2 className='title'>Frequently Asked Questions</h2>
      <div className='accordionsContainer'>
        <Accordion
          ref={(ref) => (accordionsRef.current['availability'] = ref)}
          title='Where is privauto available?'
          open={accordionsState.availability.open}
          name={accordionsState.availability.name}
          onToggle={handleAccordionToggle}
        >
          <p>
            privauto is currently available in Arkansas and Texas. Additional areas coming
            soon.
          </p>
        </Accordion>

        <Accordion
          ref={(ref) => (accordionsRef.current['paying'] = ref)}
          title='How do I pay for the vehicle I won?'
          open={accordionsState.paying.open}
          name={accordionsState.paying.name}
          onToggle={handleAccordionToggle}
        >
          <p>
            A privauto consultant will be in touch with you to instruct you how to complete
            your purchase.
          </p>
        </Accordion>

        <Accordion
          ref={(ref) => (accordionsRef.current['afterSold'] = ref)}
          title='What happens when my vehicle is sold?'
          open={accordionsState.afterSold.open}
          name={accordionsState.afterSold.name}
          onToggle={handleAccordionToggle}
        >
          <p>
            You will be instructed to bring your vehicle to the nearest concierge location where the
            condition and title of the vehicle will be matched to your supplied description. Once
            the sale is finalized, privauto will transfer the funds directly to your financial
            institution or provide you with a check for the value.
          </p>
        </Accordion>

        <Accordion
          ref={(ref) => (accordionsRef.current['cost'] = ref)}
          title='How much does privauto cost?'
          open={accordionsState.cost.open}
          name={accordionsState.cost.name}
          onToggle={handleAccordionToggle}
        >
          <p>
            There are no fees to SELL your vehicle on privauto, it's FREE. <br />
            {`A flat fee of $${process.env.NEXT_PUBLIC_BUY_FEE} will be paid by the buyer regardless of amount the vehicle sells for.`}
          </p>
        </Accordion>
      </div>

      <style jsx>{`
        .root {
          max-width: 166.7rem;
          margin: 0 auto;
          padding: 0 3.3rem;

          .title {
            margin: 0 0 2.7rem;
            font-size: 5.4rem;
            line-height: 7.1rem;
            text-align: center;
          }
          .accordionsContainer {
            :global(.title button) {
              padding: 2.5rem 7rem 2.4rem 2.9rem;
              color: var(--primary-color);
              font-size: 2rem;
            }

            :global(.children) {
              padding: 3.3rem;
              font-size: 1.8rem;
            }
          }
        }

        @media (max-width: 1024px) {
          .root {
            padding: 0 1.1rem;
            .title {
              margin: 0 0 0.9rem;
              text-align: center;
              font-size: 2rem;
              line-height: 2.6rem;
            }

            .accordionsContainer {
              :global(.title button) {
                padding: 1.5rem 7rem 1.5rem 1.8rem;
                font-size: 1.4rem;
              }

              :global(.children) {
                padding: 0.4rem 1rem 0.9rem;
                font-size: 1.4rem;
              }
            }
          }
        }
      `}</style>
    </div>
  )
}
